import { color } from 'framer-motion';
import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const BalloonRideRaces = () => {
  const balloonColors = [
    '🎈 Red Balloon',
    '🎈 Blue Balloon',
    '🎈 Green Balloon',
    '🎈 Yellow Balloon',
    '🎈 Purple Balloon',
    '🎈 Orange Balloon',
    '🎈 Pink Balloon',
    '🎈 Teal Balloon'
  ];

  const generateScenario = () => {
    const getRandomBalloon = () => ({
      color: balloonColors[Math.floor(Math.random() * balloonColors.length)],
      speed: Math.floor(Math.random() * 16) + 5,
    });

    return {
      time: Math.floor(Math.random() * 5) + 2,
      balloons: [getRandomBalloon(), getRandomBalloon()],
    };
  };

  const [scenario, setScenario] = useState(generateScenario());
  const [inputs, setInputs] = useState([]);
  const [feedback, setFeedback] = useState('');
  const [showNext, setShowNext] = useState(false);

  useEffect(() => {
    setInputs(Array(scenario.balloons.length).fill(''));
    setFeedback('');
    setShowNext(false);
  }, [scenario]);

      useEffect(() => {
      if (showNext==true) {
        const responsedata = ConstructorEventUpdateSQLStatus();
        console.log("Event completed", responsedata);
      }
    }, [showNext]);

  const handleChange = (index, value) => {
    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);
  };

  const checkAnswers = () => {
    let correct = true;
    let message = '';

    scenario.balloons.forEach((b, i) => {
      const userAnswer = parseInt(inputs[i], 10);
      const correctDistance = b.speed * scenario.time;

      if (userAnswer === correctDistance) {
        message += `✅ ${b.color} goes ${correctDistance} km!<br>`;
      } else {
        message += `❌ ${b.color} should go ${correctDistance} km!<br>`;
        correct = false;
      }
    });

    setFeedback(message);
    setShowNext(correct);
  };

  const nextScenario = () => {
    setScenario(generateScenario());
  };

  const styles = {
    body: {
      fontFamily: "'Trebuchet MS', sans-serif",
      background: 'linear-gradient(to top, #b3e5fc, #e1f5fe)',
      textAlign: 'center',
      padding: 20,
      minHeight: '100vh',
    },
    h1: {
      color: '#0288d1',
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: 20,
      margin: '30px 0',
    },
    balloon: {
      background: '#fff3e0',
      border: '3px dashed #0288d1',
      padding: 20,
      borderRadius: 20,
      width: '300px',
      maxWidth: '90%',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      margin: '0 auto',
    },
    icon: {
      fontSize: 30,
      color:"black"
    },
    input: {
      fontSize: '1rem',
      padding: '6px 12px',
      borderRadius: 6,
      border: '2px solid #f9a825',
      textAlign: 'center',
      width: 'fit-content',
      margin: '10px auto',
      display: 'block'
    },
    btn: {
      background: '#0288d1',
      color: 'white',
      padding: '12px 25px',
      border: 'none',
      borderRadius: 10,
      fontSize: 16,
      cursor: 'pointer',
      marginTop: 20,
    },
    feedback: {
      fontWeight: 'bold',
      marginTop: 20,
      fontSize: 18,
    },
    nextBtn: {
      display: showNext ? 'block' : 'none',
      marginTop: 30,
    },
  };

  return (
    <div style={styles.body}>
      <style>
        {`
          @media (max-width: 600px) {
            input {
              width: 80% !important;
            }
            div[style*="width: 300px"] {
              width: 90% !important;
            }
          }
        `}
      </style>
      <h2 style={styles.h1}>🎈 Balloon Ride Races</h2>
      <p>Solve how far each balloon travels in the given time!</p>
      <div  style={{ color:"black" }} ><strong>Time:</strong> {scenario.time} hours</div>
      <div style={styles.container}>
        {scenario.balloons.map((b, i) => (
          <div key={i} style={styles.balloon}>
            <div style={styles.icon}>{b.color}</div>
            <p>Speed: {b.speed} km/h</p>
            <label style={{ color: "black",fontSize:"15px" }} >Distance in {scenario.time} hours:</label><br />
            <input
              type="number"
              value={inputs[i] || ''}
              onChange={(e) => handleChange(i, e.target.value)}
              style={styles.input}
            /> km
          </div>
        ))}
      </div>
      <button style={styles.btn} onClick={checkAnswers}>Check Answers</button>
      <div
        style={styles.feedback}
        dangerouslySetInnerHTML={{ __html: feedback }}
      ></div>
      <div style={styles.nextBtn}>
        <button style={styles.btn} onClick={nextScenario}>Next</button>
      </div>
    </div>
  );
};

export default BalloonRideRaces;
